import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { PageBreadcrumb, TextButton, Trigger } from '@zillow/constellation';
import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

import { RoutingSelectors } from 'app/shared/selectors';
import { withErrorBoundary } from 'app/shared/components/ErrorBoundary';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import PermissionCheck from 'app/shared/components/PermissionCheck';

import PageWizard from 'app/shared/components/PageWizard';
import HowItWorks from 'app/shared/components/WizardRentGuarantee/HowItWorks';
import VerifySecurityDeposit from 'app/shared/components/WizardRentGuarantee/VerifySecurityDeposit';
import OnlineTools from 'app/shared/components/WizardRentGuarantee/OnlineTools';
import Confirmation from 'app/shared/components/WizardRentGuarantee/Confirmation';
import ExitRentGuaranteeModal from 'app/shared/components/Modal/ExitRentGuaranteeModal';

import { RENT_GUARANTEE_PATH } from 'app/shared/constants/RouteConstants';

import {
    DEEP_LINK_STEP,
    PROGRESS_STEP,
    PROGRESS_STEP_CONFIG,
    STEP,
} from './constants';

import {
    StyledContainer,
} from './StyledComponents';

const propTypes = {
    location: PropTypes.object.isRequired,
};
const defaultProps = {};

const RentGuaranteePage = ({ location, history }) => {
    const search = useSelector(state => RoutingSelectors.makeSearch(state));
    const paramStep = ZRMUtils.queryUtils.parse(search.toString()).step;
    const initialDeepLinkStep = DEEP_LINK_STEP[paramStep];
    const [currentStepKey, setCurrentStepKey] = useState(initialDeepLinkStep || STEP.HOW_IT_WORKS);
    const parts = location.pathname.split('/');
    const propertyId = parts[3];
    const config = [
        {
            stepKey: STEP.HOW_IT_WORKS,
            wizardBodyTemplate: HowItWorks,
            hideProgressStepper: true,
        },
        {
            stepKey: STEP.VERIFY_SECURITY_DEPOSIT,
            wizardBodyTemplate: VerifySecurityDeposit,
            progressStepKey: PROGRESS_STEP.VERIFY_SECURITY_DEPOSIT,
            hideProgressStepper: false,
        },
        {
            stepKey: STEP.ONLINE_TOOLS,
            wizardBodyTemplate: OnlineTools,
            progressStepKey: PROGRESS_STEP.ONLINE_TOOLS,
            hideProgressStepper: false,
        },
        {
            stepKey: STEP.CONFIRMATION,
            wizardBodyTemplate: Confirmation,
            progressStepKey: PROGRESS_STEP.CONFIRMATION,
            hideProgressStepper: false,
        },
    ];

    const handleGoToStep = (key) => {
        window.scroll(0, 0);
        setCurrentStepKey(key);
    };

    const exitRentGuaranteeModal = (props, close) => (
        <ExitRentGuaranteeModal {...props} close={close} history={history} />
    );

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={RENT_GUARANTEE_PATH}>
                <StyledContainer>
                    <PageWizard
                        steps={config}
                        progressSteps={PROGRESS_STEP_CONFIG}
                        currentStepKey={currentStepKey}
                        onGoToStep={handleGoToStep}
                        breadCrumb={(
                            <PageBreadcrumb
                                backButton={(
                                    <Trigger triggered={exitRentGuaranteeModal}>
                                        <TextButton>
                                            Exit Rent Guarantee
                                        </TextButton>
                                    </Trigger>
                                )}
                            />
                        )}
                        propertyId={propertyId}
                    />
                </StyledContainer>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

RentGuaranteePage.propTypes = propTypes;
RentGuaranteePage.defaultProps = defaultProps;

export { RentGuaranteePage };
export default withErrorBoundary(connect()(RentGuaranteePage));
